import React from "react";
import firebase from "firebase";
import { Input } from "reactstrap";

import api from "../../services/Api";
import ModalConfirm from "../hoc/ModalConfirm";
import ModalAttention from "../hoc/ModalAttention";
import { checkEMAIL } from "../../libs/Validate";

export default class RedefineEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ModalTitle: <p style={{ color: "black" }}>Atenção</p>,
      modal: false,
      modalF: false,
      modalEmail: false,
      ModalErr: false,
      ModalErrEmail: false,
      modalError: false,
      modalCampos: false,

      emailAtualOk: false,
      emailNovoOk: false,
      emailNovoConfirmOk: false,
      passAtualOk: false,
    };
  }

  handleRedefine = async () => {
    if (this.verificarCampos() === true) {
      const user = firebase.auth().currentUser;
      const credential = firebase.auth.EmailAuthProvider.credential(
        this.email.value,
        this.passwd.value
      );
      const object = {
        nome: this.props.allUser.nome,
        datanasc: this.props.allUser.datanasc,
        telefone: this.props.allUser.telefone,
        cpf: this.props.allUser.cpf,
        genero: this.props.allUser.genero,
        email: this.emailNew.value,
        foto: this.props.allUser.foto,
        uid: this.props.allUser.uid,
        id: this.props.allUser.id,
        local: this.props.allUser.local,
        nome_mae: this.props.allUser.nome_mae,
      };

      const $this = this;
      await user
        .reauthenticateWithCredential(credential)
        .then(async () => {
          await api
            .updateUser(object)
            .then(async (resp) => {
              user
                .updateEmail(this.emailNew.value)
                .then(async () => {
                  user
                    .sendEmailVerification({
                      url: "http://alertacelular.al.gov.br/",
                    })
                    .then(async () => {
                      $this.props.handleLogoutFire();
                    })
                    .catch((err) => {
                      this.setState({ modalError: true, ModalErrEmail: true });
                    });
                })
                .catch((error) => {
                  $this.setState({ modalError: true, modalEmail: true });
                  $this.emailNew = "";
                  $this.emailNew2 = "";
                  $this.passwd = "";
                });
            })
            .catch((err) => {
              if (err.response.status === 401) {
                $this.props.onModalToken();
              }
            });
        })
        .catch((err) => {
          this.setState({ modalError: true, ModalErr: true });
        });
    } else {
      this.setState({ modalError: true, modalCampos: true });
    }
  };

  verificarCampos = () => {
    if (
      this.state.emailAtualOk === true &&
      this.state.emailNovoOk === true &&
      this.state.emailNovoConfirmOk === true &&
      this.state.passAtualOk === true
    ) {
      return true;
    } else {
      return false;
    }
  };

  handleIsValid = (e) => {
    const campo = e.target.id;
    const value = e.target.value;

    const validPass = /^\w{6,50}$/;

    switch (campo) {
      case "emailAtual":
        this.setState({ emailAtualOk: checkEMAIL(value) });
        break;
      case "passAtual":
        this.setState({ passAtualOk: validPass.test(value) });
        break;
      case "emailNovo":
        this.setState({ emailNovoOk: checkEMAIL(value) });
        break;
      case "emailNovoConfirm":
        const comparar = this.emailNew.value;
        if (value === comparar && checkEMAIL(value)) {
          this.setState({ emailNovoConfirmOk: true });
        } else {
          this.setState({ emailNovoConfirmOk: false });
        }
        break;
      default:
        break;
    }
  };

  onModal = (event) => {
    this.setState({ modal: !this.state.modal });
  };

  onModalEmail = (event) => {
    this.setState({ modalEmail: !this.state.modalEmail });
  };
  onModalError = (event) => {
    this.setState({
      modalError: !this.state.modalError,
      ModalErrEmail: false,
      modalEmail: false,
      ModalErr: false,
    });
  };

  render() {
    return (
      <div className="col-md-6">
        <h2>Editar E-mail</h2>
        <div className="form-group">
          <label htmlFor="emailAtual">Email Atual*</label>
          <Input
            type="text"
            className="form-control"
            id="emailAtual"
            placeholder="Email Atual"
            invalid={!this.state.emailAtualOk}
            onChange={this.handleIsValid}
            innerRef={(ref) => (this.email = ref)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="passAtual">Senha Atual*</label>
          <Input
            type="password"
            className="form-control"
            id="passAtual"
            placeholder="Senha Atual"
            invalid={!this.state.passAtualOk}
            onChange={this.handleIsValid}
            innerRef={(ref) => (this.passwd = ref)}
          />
        </div>
        <div className="form-group ">
          <label htmlFor="emailNovo">Novo Email*</label>
          <Input
            type="text"
            className="form-control"
            id="emailNovo"
            placeholder="Email"
            invalid={!this.state.emailNovoOk}
            onChange={this.handleIsValid}
            innerRef={(ref) => (this.emailNew = ref)}
          />
        </div>
        <div className="form-group ">
          <label htmlFor="emailNovoConfirm">Confirme o Novo Email*</label>
          <Input
            type="text"
            className="form-control"
            id="emailNovoConfirm"
            placeholder="repita o seu email"
            invalid={!this.state.emailNovoConfirmOk}
            onChange={this.handleIsValid}
            innerRef={(ref) => (this.emailNew2 = ref)}
          />
        </div>
        <button className="btn btn-primary btn-sm mr-2" onClick={this.onModal}>
          Redefinir
        </button>
        &nbsp;
        <button
          className="btn btn-danger btn-sm"
          onClick={() => this.props.handleShowForm("dispositivos")}
        >
          Cancelar
        </button>
        <br />
        &nbsp;
        <ModalConfirm
          title={this.state.ModalTitle}
          show={this.state.modal}
          toggle={this.onModal}
          ok={this.handleRedefine}
          class="text-black"
        >
          <p className="text-black">Tem certeza que deseja Alterar Seus Dados?</p>
          <p className="text-black">Será Enviado ao seu novo e-mail uma Confirmação.</p>
          <p style={{ color: "red" }}>Sua sessão será finalizada.</p>
        </ModalConfirm>
        <ModalAttention
          title={this.state.ModalTitle}
          show={this.state.modalError}
          toggle={this.onModalError}
          ok={this.onModalError}
          className="text-black"
        >
          {this.state.modalEmail ? (
            <p className="text-black">Email invalido ou já existente</p>
          ) : null}
          {this.state.ModalErr ? <p style={{ color: "red" }}>EMAIL OU SENHA INCORRETAS</p> : null}
          {this.state.ModalErrEmail ? (
            <p style={{ color: "red" }}>ERROR AO ENVIAR O E-MAIL</p>
          ) : null}
          {this.state.modalCampos ? (
            <p style={{ color: "red" }}>Campos preenchidos incorretamente</p>
          ) : null}
        </ModalAttention>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Redefines/RedefineEmail.js